// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"544e1fd5","455":"8f7bbde2"}[chunkId] + ".chunk.js";
};